export default {
  profile: {
    email: '',
    identificationMobileNr: '',
    userProfile: {}
  }
}
